import React from 'react';

// You can create a simple CSS file for styling or use inline styles if you prefer.
// For example, create a styles.css and import it: import './styles.css';

const containerStyle = {
  padding: '20px 40px',
  fontFamily: 'Arial, sans-serif',
  lineHeight: '1.6',
  color: '#333',
  maxWidth: '800px',
  margin: '0 auto'
};

const headingStyle = {
  borderBottom: '2px solid #eee',
  paddingBottom: '10px',
  marginBottom: '20px'
};

const subHeadingStyle = {
  marginTop: '30px'
};


const SafetyPolicy = () => {
  return (
    <div style={containerStyle}>
      <h1 style={headingStyle}>Safety Policy & Standards</h1>
      <p>
        Welcome to Greatly Social. We are committed to creating a safe and positive environment for all our users. This page outlines our standards and practices, particularly our zero-tolerance policy against Child Sexual Abuse and Exploitation (CSAE) and other harmful content.
      </p>

      <h2 style={subHeadingStyle}>Zero-Tolerance Policy on Child Sexual Abuse Material (CSAM)</h2>
      <p>
        Greatly Social has a strict, zero-tolerance policy against any content that depicts, promotes, or facilitates child sexual abuse and exploitation. The creation, distribution, or accessing of Child Sexual Abuse Material (CSAM) is illegal and causes severe harm. Any account found sharing or engaging with such content will be permanently banned, and the content and associated user information will be reported to law enforcement authorities, including the National Center for Missing & Exploited Children (NCMEC).
      </p>

      <h2 style={subHeadingStyle}>Content Moderation</h2>
      <p>
        We employ a combination of automated detection technologies and trained human moderators to identify and remove content that violates our policies. Our team works 24/7 to review user reports and proactively monitor the platform for harmful material.
      </p>

      <h2 style={subHeadingStyle}>How to Report a Concern</h2>
      <p>
        User reporting is a critical part of keeping our community safe. If you see any content or behavior that you believe violates our policies or is illegal, please report it immediately using our in-app reporting tools.
      </p>
      <ul>
        <li><strong>Reporting a Post:</strong> Tap the three-dot menu (...) on any post and select 'Report'.</li>
        <li><strong>Reporting a User:</strong> Navigate to the user's profile, tap the three-dot menu (...), and select 'Report'.</li>
      </ul>
      <p>
        Every report is reviewed by our safety team. We take all reports seriously and will take appropriate action, which may include content removal, account suspension, or a permanent ban.
      </p>

      <h2 style={subHeadingStyle}>Cooperation with Law Enforcement</h2>
      <p>
        We are committed to complying with all relevant child safety laws. We cooperate fully with law enforcement and authorized reporting agencies in the investigation of child sexual abuse and exploitation.
      </p>
    </div>
  );
};

export default SafetyPolicy;